const getAnalyticsUrl = () => {
    const hst = document.location.hostname;
    const ssaSite = hst.includes("ssa.");
    const riaSite = hst.includes("ria.");
    const annMyAcct =
        hst.includes("annuities.") &&
        (hst.includes("myaccount.") || hst.includes("myaccount-"));
    const annSite = hst.includes("annuities.") && !annMyAcct;

    const annFinPro = process.env.REACT_APP_ADOBE_ANALYTICS_ANN_BRK;
    const ssaUsers = process.env.REACT_APP_ADOBE_ANALYTICS_SSA;
    const riaUsers = process.env.REACT_APP_ADOBE_ANALYTICS_RIA;
    const myAccountUsers = process.env.REACT_APP_ADOBE_ANALYTICS_MYACCOUNT;

    if (ssaSite) {
        return ssaUsers;
    }
    if (riaSite) {
        return riaUsers;
    }
    if (annSite) {
        return annFinPro;
    }
    if (annMyAcct) {
        return myAccountUsers;
    }
};

export const appendAnalytics = () => {
    const adobeSourceURL = getAnalyticsUrl();
    if (!adobeSourceURL) {
        console.warn(
            "No Adobe Analytics source URL found for this site/environment. Analytics will not be loaded."
        );
        return;
    }
    const script = document.createElement("script");
    script.src = adobeSourceURL;
    script.async = true;
    document.body.appendChild(script);
};
